import Qs from "qs";
const mixin = {
	mounted() {
		if (this.incomingModal) {
			let parameters = {
				...this.$parent.$parent.trendfilters,
				...this.$parent.$parent.semanticfilters,
				...this.$parent.$parent.modalkeywords,
			};
			this.loadComponent(parameters);
		} else if (this.explorePage) {
			let parameters = {
				...this.$parent.$parent.filters,
			};
			this.loadComponent(parameters);
		} else {
			this.loadComponent(this.$store.getters.parameters);
		}
	},
	data() {
		return {
			dialogLoad: null,
			languageslist: [
				{ id: "none", value: "Any language" },
				{ id: "ar", value: "Arabic" },
				{ id: "zh-CN", value: "Chinese (Simplified)" },
				{ id: "zh-TW", value: "Chinese (Traditional)" },
				{ id: "en", value: "English" },
				{ id: "fr", value: "French" },
				{ id: "de", value: "German" },
				{ id: "el", value: "Greek" },
				{ id: "it", value: "Italian" },
				{ id: "ja", value: "Japanese" },
				{ id: "ko", value: "Korean" },
				{ id: "pt", value: "Portuguese" },
				{ id: "pt-br", value: "Portuguese - Brazil" },
				{ id: "ru", value: "Russian" },
				{ id: "es", value: "Spanish" },
			],
			countrieslist: [
				{ id: "", value: "Any country" },
				{ id: "ar", value: "Argentina" },
				{ id: "au", value: "Australia" },
				{ id: "at", value: "Austria" },
				{ id: "be", value: "Belgium" },
				{ id: "br", value: "Brasil" },
				{ id: "ca", value: "Canada" },
				{ id: "cl", value: "Chile" },
				{ id: "cn", value: "China" },
				{ id: "co", value: "Colombia" },
				{ id: "cu", value: "Cuba" },
				{ id: "cz", value: "Czech Republic" },
				{ id: "da", value: "Denmark" },
				{ id: "eg", value: "Egypt" },
				{ id: "fr", value: "France" },
				{ id: "de", value: "Germany" },
				{ id: "gr", value: "Greece" },
				{ id: "hk", value: "Hong-Kong" },
				{ id: "hu", value: "Hungaria" },
				{ id: "in", value: "India" },
				{ id: "id", value: "Indonesia" },
				{ id: "ie", value: "Ireland" },
				{ id: "il", value: "Israel" },
				{ id: "it", value: "Italia" },
				{ id: "jp", value: "Japan" },
				{ id: "kr", value: "Korea" },
				{ id: "mx", value: "Mexico" },
				{ id: "ma", value: "Morocco" },
				{ id: "nl", value: "Netherlands" },
				{ id: "nz", value: "New-Zealand" },
				{ id: "no", value: "Norway" },
				{ id: "pl", value: "Poland" },
				{ id: "pt", value: "Portugal" },
				{ id: "qa", value: "Qatar" },
				{ id: "ru", value: "Russia" },
				{ id: "sa", value: "Saudi Arabia (السعودية)" },
				{ id: "sg", value: "Singapor" },
				{ id: "za", value: "South Africa" },
				{ id: "es", value: "Spain" },
				{ id: "se", value: "Sweden" },
				{ id: "ch", value: "Switzerland" },
				{ id: "tw", value: "Taiwan" },
				{ id: "th", value: "Thailand" },
				{ id: "tr", value: "Turkey" },
				{ id: "gb", value: "UK" },
				{ id: "ua", value: "Ukraine" },
				{ id: "ae", value: "United Arab Emirates (الإمارات)" },
				{ id: "us", value: "USA" },
				{ id: "ve", value: "Venezuela" },
				{ id: "vn", value: "Vietnam" },
			],
			graphColor: [
				"#32D1CD",
				"#7CB5EC",
				"#36802D",
				"#FF9A00",
				"#ff6827",
				"#ef4040",
				"#EFBBFF",
				"#a60ca6",
				"#F1C40F",
				"#A0D6B4",
				"#36802D",
				"#243F5B",
				"#8D864A",
				"#845422",
				"#4BCC2E",
				"#BE29EC",
				"#FF0081",
				"#0C457D",
				"#036",
				"#FFDAB9",
				"#DAA520",
				"#F66",
				"#66CDAA",
				"#FFF68F",
				"#B0E0E6",
				"#8A2BE2",
				"#696966",
				"#000000",
			],
		};
	},
	props: {
		incomingModal: {
			default: false,
		},
		explorePage: {
			default: false,
		},
	},
	methods: {
		loadComponent(/*parameters*/) {
			//console.log(parameters);
			// To be overwritten
		},
		getData(url, params, arrayFormat = "brackets") {
			//console.log(this.$store.getters.parameters);
			this.$axios
				.get(this.$backendUrl + url, {
					params: params,
					paramsSerializer: function (params) {
						return Qs.stringify(params, {
							arrayFormat: arrayFormat,
						});
					},
				})
				.then((response) => {
					this.treatResponse(response);
				})
				.catch(function (error) {
					console.log("Error axios getData");
					console.log(error);
				});
		},
		postData(url, params) {
			this.$axios.post(this.$backendUrl + url, params).then((response) => {
				this.treatPostResponse(response);
			});
		},
		storeWatcher(newValue, oldValue) {
			return newValue.valueOf() !== oldValue.valueOf();
		},
		confirmLoadingModal(status = "close", message = "In progress...") {
			this.confirmColor = "orange";
			this.confirmTitle = message;
			this.confirmType = "loading";
			status === "close" ? this.$refs.confirm.close() : this.$refs.confirm.open();
		},
		confirmInputAddModal(message) {
			this.confirmColor = "orange";
			this.confirmTitle = "Edit";
			this.confirmType = "edit";
			this.confirmMessage = message;
			this.$refs.confirminput.open();
		},
		confirmInputDeleteModal(message) {
			this.confirmColor = "red";
			this.confirmTitle = "Delete";
			this.confirmType = "edit";
			this.confirmMessage = message;
			this.$refs.confirminput.open();
		},
		confirmErrorModal(message) {
			this.confirmLoadingModal();
			this.confirmColor = "red";
			this.confirmTitle = "ERROR";
			this.confirmType = "alert";
			this.confirmMessage = message;
			this.$refs.confirm.open();
		},
		confirmSuccessModal(message) {
			this.confirmLoadingModal();
			this.confirmColor = "green";
			this.confirmTitle = "SUCCESS";
			this.confirmType = "alert";
			this.confirmMessage = message;
			this.$refs.confirm.open();
		},
	},
};

export default mixin;
